export default __webpack_public_path__ + "static/media/Roadmap_graphic_01_cropped.c241e9e4.png";